module.exports = __webpack_public_path__ + "media/images/icon-notification-on@3x-643d90e5be38ca21fb047739f57d7605.png";